import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { AppCommonModule } from '../common.module';
import { MainDialogComponent } from '../components/main-dialog/main-dialog.component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.dialog.html',
  styleUrls: ['./confirm-dialog.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule, MainDialogComponent,
    FormsModule,
  ],
})
export class ConfirmDialogComponent {

  titleS = signal<string>('');
  textS = signal<string>('');
  buttonsS = signal<string[]>([]);
  hasInputS = signal('');

  inputValue = signal('');

  constructor(
    private _modal: ModalController,
    navParams: NavParams,
  ) {
    this.titleS.set(navParams.get('title'));
    this.textS.set(navParams.get('text'));
    this.buttonsS.set(navParams.get('buttons') ?? []);
    this.hasInputS.set(navParams.get('hasInput') ?? '');
  }

  select(index: number) {
    this._modal.dismiss({ index, value: this.inputValue() });
  }

  dismiss() {
    this._modal.dismiss();
  }
}
